import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { getModulesArray } from '@/utils'
import { getAdminAccessFlag, clearAdminAccessFlag } from '@/utils/global/adminAccess'
const modulesFiles = import.meta.glob('./modules/**/*.ts', { eager: true })
const moduleRoutes = getModulesArray(modulesFiles)
const adminModulesFiles = import.meta.glob('./adminModules/**/*.ts', { eager: true })
const adminModuleRoutes = getModulesArray(adminModulesFiles)
// 定义路由
const childrenRoutes: Array<RouteRecordRaw> = [...moduleRoutes]
const childrenAdminRoutes: Array<RouteRecordRaw> = [...adminModuleRoutes]

const routes: Array<RouteRecordRaw> = [
	{
		path: '/login',
		name: 'login',
		meta: { title: '登录' },
		component: () => import('@/views/login/index.vue')
	},
	{
		path: '/',
		// redirect: '/home/dashboard'
		redirect: '/home/homeIndex'
	},
	// {
	// 	path: '/home',
	// 	name: 'Home',
	// 	meta: { title: '首页' },
	// 	component: () => import('@/views/home/Home.vue')
	// },
	{
		path: '/home/:param(last|collect|share|dashboard|userCenter|recycleBin|homeIndex|upload)?',
		name: 'Home',
		meta: { title: '文档管理' },
		component: () => import('@/views/doc-mgt/index.vue'),
		props: true,
		children: childrenRoutes
	},
	{
		path: '/admin',
		name: 'Admin',
		meta: { title: '文档管理' },
		component: () => import('@/views/admin/index.vue'),
		props: true,
		children: childrenAdminRoutes
	},
	// 视频播放页
	{
		path: '/video',
		name: 'video',
		meta: { title: '视频播放' },
		component: () => import('@/views/video-player/index.vue')
	},
	{
		path: '/404',
		name: '404',
		meta: { title: '404' },
		component: () => import('@/views/404/index.vue')
	},
	{
		path: '/sliceList',
		name: 'sliceList',
		meta: { title: '切片列表' },
		component: () => import('@/views/slice/index.vue')
	},
	{
		path: '/docOverview/:id?/:type?/:inviteCode?',
		name: 'docOverview',
		meta: { title: '文件概览' },
		component: () => import('@/views/doc-overview/index.vue')
	},
	{
		path: '/preview',
		name: 'preview',
		meta: { title: '文件预览' },
		component: () => import('@/views/doc-overview/preview.vue')
	},
	{
		path: '/redirect',
		children: [
			{
				path: '/redirect/:path(.*)',
				component: () => import('@/views/redirect/index.vue')
			}
		]
	}
]
// 实列化router
const router = createRouter({
	history: createWebHistory(process.env.VITE_APP_ROOT),
	routes
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
	if (to.path === '/home/recycleBin' || to.path === '/admin/recycleBin') {
		// 回收站不进行任何处理
		next()
	} else if (to.path.indexOf('/admin') !== -1) {
		const isAccessed = getAdminAccessFlag()
		if (isAccessed) {
			next()
		} else {
			// 非法访问，重定向到首页
			next('/')
		}
	} else {
		// 访问其他页面，清除标志
		clearAdminAccessFlag()
		next()
	}
})

export default router
